import { faCircleMinus, faCirclePlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styles from './ReportActivityForm.module.scss';

interface StepperProps {
    value: number;
    disabled?: boolean;
    /* eslint-disable-next-line no-unused-vars */
    onChange: (value: number) => void;
}

const StepperComponent: React.FC<StepperProps> = ({ value, disabled, onChange }) => (
    <div className={styles.stepper}>
        <button
            type="button"
            className={styles.stepperButton}
            disabled={disabled}
            onClick={() => onChange(Math.max(0, value - 1))}
        >
            <FontAwesomeIcon icon={faCircleMinus} />
        </button>
        <span className={styles.stepperValue}>{value}</span>
        <button
            type="button"
            className={styles.stepperButton}
            disabled={disabled}
            onClick={() => onChange(value + 1)}
        >
            <FontAwesomeIcon icon={faCirclePlus} />
        </button>
    </div>
);

export const Stepper = React.memo(StepperComponent);
